import LandingHero from "../components/landing/LandingHero";
import WhyFail from "../components/landing/WhyFail";
import DVXMethod from "../components/landing/DVXMethod";
import MeetCoach from "../components/landing/MeetCoach";
import OfferStack from "../components/landing/OfferStack";
import ResultsSection from "../components/landing/ResultsSection";
import ScarcitySection from "../components/landing/ScarcitySection";
import ApplicationForm from "../components/landing/ApplicationForm";
import FloatingCTA from "../components/landing/FloatingCTA";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[var(--dvx-bg)] transition-colors duration-300">
      <MeetCoach />
      <LandingHero />
      <WhyFail />
      <DVXMethod />
      <OfferStack />
      <ResultsSection />
      <ScarcitySection />
      <div id="application">
        <ApplicationForm />
      </div>
      <FloatingCTA />
    </div>
  );
}
